module.exports = __webpack_public_path__ + "img/reorder.4cd1be94.svg";